var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#7AC943",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58252 18.5925V33.0225H35.5975V18.5375C35.5975 18.5375 29.7925 14.5325 29.525 14.495C29.2575 14.4575 21.46 7.32001 21.46 7.32001L12.865 14.2525L6.58252 18.5925Z",
    fill: "#F8C778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58252 18.5775H13.4325L13.425 33.0075H14.5625L14.57 15.44L21.29 9.52497L28.07 15.725L28.0525 33.0075H29.1175L29.135 18.495L35.5975 18.54V17.6775L29.7025 14.5175L21.8175 7.58997L13.1125 14.375L6.58752 17.7525L6.58252 18.5775Z",
    fill: "#F5B03F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.275 12.6425C8.23 12.715 6.4875 17.52 6.455 17.62C6.4225 17.72 6.505 17.8375 6.705 17.855C6.905 17.8725 13.8025 17.855 13.8025 17.855L13.7825 14.91C13.7825 14.91 21.1875 8.24501 21.27 8.24501C21.3525 8.24501 28.815 15.0825 28.8325 15.185C28.85 15.285 28.865 17.74 28.865 17.74C28.865 17.74 35.4275 17.79 35.5625 17.8075C35.6975 17.825 35.73 17.64 35.6125 17.29C35.495 16.94 34.125 12.715 34.025 12.6475C33.925 12.58 28.515 12.58 28.515 12.58C28.515 12.58 21.7375 6.34001 21.62 6.24001C21.5025 6.14001 21.1525 5.98751 20.8425 6.29751C20.57 6.57001 13.81 12.63 13.81 12.63C13.81 12.63 8.325 12.5575 8.275 12.6425Z",
    fill: "#A62714"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9775 22.1475L15.975 33.0175H26.565V22.1475C26.565 22.1475 15.9775 22.12 15.9775 22.1475Z",
    fill: "#CF6150"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90999 33.0625C6.00249 33.2025 7.08249 33.1375 9.95999 33.1525C12.8375 33.1675 13.675 33.1625 13.825 33.1325C13.9725 33.1025 14.0925 32.455 13.995 31.8925C13.8875 31.275 13.5175 30.6925 12.9175 30.505C12.115 30.255 11.62 30.485 11.235 30.35C10.85 30.2175 9.72249 29.6525 8.57999 29.7275C7.59999 29.79 6.90249 30.0775 6.29499 30.9725C5.64249 31.935 5.84999 32.9725 5.90999 33.0625Z",
    fill: "#7DB240"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5225 33.0025C36.67 32.9 36.6575 30.06 34.6825 29.8425C33.2 29.68 32.8125 30.3175 32.5625 30.3175C32.31 30.3175 31.35 29.85 30.025 30.3625C28.3775 31 28.4075 32.855 28.4675 33.0325C28.5275 33.21 30.2325 33.165 32.575 33.18C34.9175 33.195 36.33 33.1375 36.5225 33.0025Z",
    fill: "#7DB240"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89252 19.4075H12.565V23.17H7.83002C7.83002 23.17 7.86002 19.4375 7.89252 19.4075Z",
    fill: "#3E737C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82998 24.9275H12.4825V28.5675H7.78998C7.78998 28.57 7.80998 24.9075 7.82998 24.9275Z",
    fill: "#3E737C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59997 20.095H11.775V22.5825H8.55997C8.55997 22.5825 8.53747 20.115 8.59997 20.095Z",
    fill: "#A7D0D7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45752 25.535H11.815V27.9425H8.45752C8.45752 27.9425 8.45752 25.515 8.45752 25.535Z",
    fill: "#A7D0D7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9175 19.63H34.57V23.3725H29.8975C29.8975 23.3725 29.9175 19.57 29.9175 19.63Z",
    fill: "#3E737C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.565 20.2775H33.9025V22.705H30.565C30.565 22.705 30.565 20.235 30.565 20.2775Z",
    fill: "#A7D0D7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8575 25.15H34.49V28.69H29.8575C29.8575 28.69 29.8275 25.1825 29.8575 25.15Z",
    fill: "#3E737C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.585 25.7975V27.9825H33.76V25.7775C33.76 25.7775 30.555 25.7675 30.585 25.7975Z",
    fill: "#A7D0D7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.515 33.0225L17.5125 23.3325H25.1375V33.0225C25.1375 33.0225 17.535 33.0225 17.515 33.0225Z",
    fill: "#3E737C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.235 25.31V24.035C24.235 24.035 18.4325 24.035 18.455 24.035V25.31H24.235Z",
    fill: "#A7D0D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.235 25.9475H18.455V29.265H24.235V25.9475Z",
    fill: "#A7D0D7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.235 29.9475H18.455V31.6825H24.235V29.9475Z",
    fill: "#A7D0D7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 25.6625V32.19H21.73V25.595C21.73 25.595 21.115 25.6625 21.07 25.6625Z",
    fill: "#3E737C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.115 12.015C18.5225 12.0375 16.785 13.97 16.9175 16.455C17.045 18.87 18.9625 20.385 21.18 20.3225C23.51 20.2575 25.18 18.3875 25.245 16.17C25.31 13.9525 23.51 11.995 21.115 12.015Z",
    fill: "#3E737C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.05 12.7625C18.94 12.7625 17.5325 14.3675 17.6225 16.3C17.7075 18.165 18.9625 19.575 21.1175 19.575C23.095 19.575 24.395 17.95 24.435 16.2775C24.4775 14.4525 23.115 12.7625 21.05 12.7625Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.435 16.365C20.435 16.365 19.21 17.395 19.1425 17.515C19.075 17.635 19.0775 17.8325 19.24 17.965C19.405 18.0975 19.5675 18.02 19.6675 17.9425C19.765 17.865 21.0575 16.805 21.0575 16.805C21.0575 16.805 21.475 16.7975 21.5725 16.3025C21.65 15.9075 21.365 15.7225 21.365 15.7225C21.365 15.7225 21.32 13.3575 21.3 13.1825C21.2825 13.0525 21.1475 12.93 21.0275 12.9425C20.9075 12.9525 20.7875 13.02 20.775 13.215C20.7625 13.41 20.75 15.675 20.75 15.675C20.75 15.675 20.575 15.74 20.4775 15.9275C20.38 16.1125 20.435 16.365 20.435 16.365Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school-icon.4c33f4b83a9e35632006dd19265355ae.svg";
export { ForwardRef as ReactComponent };